export default "__VITE_ASSET__rKIXW3Hb__"